export function FileDownloadIcon(): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="2 0 8 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.99935 7.99984V9.99984H1.99935V7.99984H0.666016V9.99984C0.666016 10.7332 1.26602 11.3332 1.99935 11.3332H9.99935C10.7327 11.3332 11.3327 10.7332 11.3327 9.99984V7.99984H9.99935ZM9.33268 5.33317L8.39268 4.39317L6.66602 6.11317V0.666504H5.33268V6.11317L3.60602 4.39317L2.66602 5.33317L5.99935 8.6665L9.33268 5.33317Z" />
    </svg>
  );
}
